import { render, staticRenderFns } from "./Commissions.vue?vue&type=template&id=7377770a&scoped=true"
import script from "./Commissions.vue?vue&type=script&lang=ts"
export * from "./Commissions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7377770a",
  null
  
)

export default component.exports